import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import Modal from '../helpers/Modal';

interface ShareBuildModalProps {
  isOpen: boolean;
  onClose: () => void;
  shareLink: string;
}

const ShareBuildModal: React.FC<ShareBuildModalProps> = ({
  isOpen,
  onClose,
  shareLink
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Share Build" size="lg" position="top-center">
      <div className="space-y-4">
        <p className="text-gray-300">
          Your build is ready to share! Copy the link below to share it with others.
        </p>
        
        <div className="flex gap-2">
          <input
            type="text"
            readOnly
            value={shareLink}
            aria-label="Share Link"
            className="flex-1 p-3 rounded-lg bg-slate-800 text-white border border-sworn-brown focus:outline-none"
          />
          <button
            onClick={handleCopy}
            className="bg-sworn-gold hover:bg-[#d4963d] text-black font-bold py-2 px-4 rounded-lg transition-colors flex items-center gap-2"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ShareBuildModal;
